import { useMemo } from 'react'
import { Card } from '../../SharedComponents/Card'
import { DataTable } from './DataTable'
import { FILE_STATUSES } from '../../../lib/api/moduleManager/getFiles'
import {
  formatCurrency,
  formatNegative,
  formatPercent,
} from '../../../lib/utils/format'
import type { Column, DisplayRow, FileTotalsCardProps } from '../types'
import styles from '../index.module.css'

const formatDealValue = (r: DisplayRow): string =>
  r.file_status === 'Clawback'
    ? formatNegative(r.deal_value)
    : formatCurrency(r.deal_value)

const columns: Column<DisplayRow>[] = [
  { title: 'File Status', key: 'file_status', accessor: 'file_status' },
  {
    title: 'Units',
    key: 'units',
    render: (r) => (r.units == null ? '—' : String(r.units)), // can remove this once BE returns null statuses
  },
  {
    title: 'True Debt ($)',
    key: 'true_debt',
    render: (r) => formatCurrency(r.true_debt),
  },
  {
    title: 'Deal Value',
    key: 'deal_value',
    render: formatDealValue,
  },
  {
    title: '%',
    key: 'percent',
    render: (r) => formatPercent(r.percent),
  },
]

export default function FileTotalsCard({ rows, loading }: FileTotalsCardProps) {
  // temporary hack. BE will return the rows in the correct order later with all statuses even if null
  const orderedRows = useMemo<DisplayRow[]>(
    () =>
      FILE_STATUSES.map(
        (status) =>
          rows.find((r) => r.file_status === status) ?? {
            file_status: status,
            units: null,
            true_debt: null,
            deal_value: null,
            percent: null,
          },
      ),
    [rows],
  )

  return (
    <Card>
      <div className={styles.cardHeader}>MY FILES — Topline</div>
      <DataTable
        columns={columns}
        data={orderedRows}
        rowKey="file_status"
        loading={loading}
      />
    </Card>
  )
}
